<template>
  <v-footer
    id="core-footer"
    absolute
    height="70"
    style="border-top:0px"
  >
    <v-spacer />
    <span 
      v-if="isToddOrg" 
      class="font-weight-bold copyright font-calibri"
    >
      &copy;
      {{ (new Date()).getFullYear() }}
      Selat Group
    </span>
    <span
      v-else
      class="font-weight-bold copyright font-calibri"
    >
      &copy;
      {{ (new Date()).getFullYear() }}    
      <a
        href="https://www.katimas.my"
        target="_blank"
      >Rex Technologies</a>
    </span>
  </v-footer>
</template>

<script>
  export default {
    data () {
      return {
        appOrg: process.env.VUE_APP_ORG,
        isToddOrg: false,
      }
    },
    created () {
      this.isToddOrg = this.appOrg === 'todd' 
    },     
  }
</script>

<style>
#core-footer {
  z-index: 0;
}

.font-calibri{
  font-family: calibri !important;
}
</style>
